import { render } from "./navbar.vue?vue&type=template&id=6a444834&scoped=true"
import script from "./navbar.vue?vue&type=script&lang=ts"
export * from "./navbar.vue?vue&type=script&lang=ts"

import "./navbar.vue?vue&type=style&index=0&id=6a444834&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a444834"

export default script